import { Minus, Plus } from "lucide-react";

const parsePrice = (t) => {
  const m = (t || "").match(/\d+(?:[.,]\d+)?/);
  return m ? Number(m[0].replace(",", ".")) : 0;
};

export const itemsTotal = (services, items) =>
  items.reduce((sum, it) => sum + it.qty * parsePrice(services.find((s) => s.name === it.name)?.price), 0);

export default function ServicePicker({ services, items, onChange, testPrefix = "booking" }) {
  const qtyOf = (name) => items.find((i) => i.name === name)?.qty || 0;
  const setQty = (name, qty) => {
    const rest = items.filter((i) => i.name !== name);
    onChange(qty > 0 ? [...rest, { name, qty: Math.min(qty, 20) }] : rest);
  };
  const total = itemsTotal(services, items);
  const slug = (n) => n.toLowerCase().replace(/[^a-z0-9]+/g, "-");

  return (
    <div>
      <div className="grid grid-cols-2 gap-2 mt-3">
        {services.map((s) => {
          const qty = qtyOf(s.name);
          return (
            <div
              key={s.id || s.name}
              data-testid={`${testPrefix}-service-${slug(s.name)}`}
              onClick={() => qty === 0 && setQty(s.name, 1)}
              role="button"
              className={`rounded-xl border px-3 py-2.5 text-left text-sm transition-colors duration-200 cursor-pointer ${
                qty > 0 ? "border-gold bg-rosesoft text-obsidian" : "border-sand bg-cream text-cocoa hover:border-gold/50"
              }`}
            >
              <span className="font-medium block">{s.name}</span>
              <div className="flex items-center justify-between mt-0.5">
                <span className="text-xs text-gold">{s.price}</span>
                {qty > 0 && (
                  <span className="inline-flex items-center gap-1" onClick={(e) => e.stopPropagation()}>
                    <button type="button" onClick={() => setQty(s.name, qty - 1)} data-testid={`${testPrefix}-qty-minus-${slug(s.name)}`} aria-label="Quitar uno" className="w-6 h-6 rounded-full bg-cream border border-gold/50 text-obsidian flex items-center justify-center"><Minus className="w-3 h-3" /></button>
                    <span data-testid={`${testPrefix}-qty-${slug(s.name)}`} className="w-5 text-center text-sm font-medium">{qty}</span>
                    <button type="button" onClick={() => setQty(s.name, qty + 1)} data-testid={`${testPrefix}-qty-plus-${slug(s.name)}`} aria-label="Añadir uno" className="w-6 h-6 rounded-full bg-gold text-white flex items-center justify-center"><Plus className="w-3 h-3" /></button>
                  </span>
                )}
              </div>
            </div>
          );
        })}
      </div>
      {items.length > 0 && (
        <p data-testid={`${testPrefix}-items-summary`} className="mt-2 text-xs text-cocoa">
          {items.map((i) => `${i.name}${i.qty > 1 ? ` ×${i.qty}` : ""}`).join(" + ")} · <b>aprox. {total.toLocaleString("es-ES")} €</b>
        </p>
      )}
      <p className="text-[11px] text-taupe mt-1">Puedes elegir varios servicios y la cantidad de cada uno (por ejemplo, dos cejas).</p>
    </div>
  );
}
